import ExcelJS from 'exceljs';
import { restarSeisHoras } from '../fechaMexico';

const COLOR_ENCABEZADO = 'FF1F4E78'; // azul oscuro
const COLOR_FILA_PAR = 'FFEAF1F8'; // azul muy claro, para el efecto zebra

const ANCHOS_COLUMNA = {
  Email: 30,
  'ID Materia': 12,
  Código: 12,
  Materia: 24,
  Categoría: 12,
  Registro: 12,
  'Fecha de registro': 18,
};

export async function exportarRegistrados(registrados, nombreArchivo = 'alumnos_registrados.xlsx') {
  const filas = registrados.map((r) => ({
    Email: r.email,
    'ID Materia': r.idMat,
    Código: r.materiaCode,
    Materia: r.materiaName,
    Categoría: r.materiaCategory,
    Registro: r.idRegistro,
    'Fecha de registro': restarSeisHoras(r.fechaRegistro) || '',
  }));

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet('Registrados');
  const claves = filas.length > 0 ? Object.keys(filas[0]) : Object.keys(ANCHOS_COLUMNA);

  sheet.columns = claves.map((clave) => ({
    header: clave,
    key: clave,
    width: ANCHOS_COLUMNA[clave] ?? Math.max(10, clave.length + 2),
  }));

  filas.forEach((fila) => sheet.addRow(fila));

  const filaEncabezado = sheet.getRow(1);
  filaEncabezado.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: COLOR_ENCABEZADO } };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
  });
  filaEncabezado.height = 20;

  for (let numFila = 2; numFila <= filas.length + 1; numFila += 1) {
    if (numFila % 2 === 0) {
      sheet.getRow(numFila).eachCell({ includeEmpty: true }, (cell) => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: COLOR_FILA_PAR } };
      });
    }
  }

  sheet.views = [{ state: 'frozen', ySplit: 1 }];

  if (claves.length > 0) {
    sheet.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: filas.length + 1, column: claves.length },
    };
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = nombreArchivo;
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  URL.revokeObjectURL(url);
}
